(() => {
  'use strict';
  const labelsNode = document.getElementById('JBFirstProductLabels');
  if (!labelsNode) return;
  const labels = JSON.parse(labelsNode.textContent);
  const uncertain = '__jb_unsure__';
  // Wrapped Solitaire keeps native option IDs, variants and prices intact.
  const wrappedShapeImages = {
    oval: 'https://cdn.shopify.com/s/files/1/0671/9360/2266/files/jb-shape-oval.png?v=1792305826',
    pear: 'https://cdn.shopify.com/s/files/1/0671/9360/2266/files/jb-shape-pear.png?v=1792305833',
    marquise: 'https://cdn.shopify.com/s/files/1/0671/9360/2266/files/jb-shape-marquise.png?v=1792305840'
  };
  const after = (node, previous) => {
    if (node && previous && (node.parentNode !== previous.parentNode || node.previousElementSibling !== previous)) previous.after(node);
  };
  const ordered = (parent, nodes) => {
    let next = null;
    [...nodes].filter(Boolean).reverse().forEach(node => {
      if (node.parentNode !== parent || node.nextElementSibling !== next) parent.insertBefore(node, next);
      next = node;
    });
  };
  const group = (parent, name) => {
    let node = parent.querySelector(`:scope > .${name}`);
    if (!node) { node = document.createElement('div'); node.className = name; parent.append(node); }
    return node;
  };
  function originButtons(origin) {
    const select = origin?.querySelector('select[data-jb-stone-origin]');
    if (!select || origin.querySelector('.jb-first-origin-buttons')) return;
    const buttons = document.createElement('div'); buttons.className = 'jb-first-origin-buttons'; buttons.setAttribute('role','group');
    buttons.setAttribute('aria-label',origin.querySelector('.form__label')?.textContent || '');
    const options = [...select.options].filter(option => option.value && !option.disabled).sort((a,b) => Number(b.value === 'Natural')-Number(a.value === 'Natural'));
    options.forEach(option => {
      const button = document.createElement('button'); button.type = 'button'; button.className = 'button outline'; button.dataset.originValue = option.value;
      const caption = document.createElement('span'); caption.textContent = option.textContent; button.append(caption);
      button.addEventListener('click', () => { select.value = option.value; select.dispatchEvent(new Event('input',{bubbles:true})); select.dispatchEvent(new Event('change',{bubbles:true})); });
      buttons.append(button);
    });
    const error = document.createElement('p'); error.className = 'jb-first-origin-error'; error.setAttribute('role','alert'); error.textContent = labels.originRequired; error.hidden = true;
    select.after(buttons,error); select.classList.add('jb-first-origin-source'); select.setAttribute('aria-hidden','true'); select.tabIndex = -1;
    const sync = () => { [...buttons.children].forEach(button => button.setAttribute('aria-pressed',String(button.dataset.originValue === select.value))); if(select.value) error.hidden = true; };
    origin.addEventListener('change',sync); sync();
  }
  function refineSelect(select) {
    if(select.dataset.jbRefinedSelect) { select.jbRefinedSelectSync?.(); return; }
    const frame = select.parentElement;
    if(!frame || !frame.classList.contains('select')) return;
    select.dataset.jbRefinedSelect = 'true';
    frame.classList.add('jb-refined-select');
    const value = document.createElement('span'); value.className = 'jb-refined-select__value'; value.setAttribute('aria-hidden','true');
    const sync = () => { value.textContent = select.selectedOptions[0]?.textContent.trim() || ''; frame.classList.toggle('jb-refined-select--disabled',select.disabled); };
    select.jbRefinedSelectSync = sync;
    frame.append(value);
    select.addEventListener('input',sync); select.addEventListener('change',sync);
    new MutationObserver(sync).observe(select,{attributes:true,childList:true,subtree:true,attributeFilter:['disabled','selected']});
    sync();
  }
  function wrappedChoiceButtons(field, kind) {
    const select = field?.querySelector('select');
    if (!select) return;
    if (field.jbWrappedChoiceSync) { field.jbWrappedChoiceSync(); return; }
    const origin = kind === 'origin';
    field.classList.add(origin ? 'jb-wrapped-origin' : 'jb-wrapped-shape');
    const label = field.querySelector('.form__label');
    if (label) label.textContent = origin ? 'Stone origin' : 'Shape';
    const buttons = document.createElement('div');
    buttons.className = origin ? 'jb-first-origin-buttons' : 'jb-wrapped-shape-buttons';
    buttons.setAttribute('role', 'group');
    buttons.setAttribute('aria-label', origin ? 'Stone origin' : 'Diamond shape');
    const order = origin ? ['Natural', 'Lab-grown'] : ['Oval', 'Pear', 'Marquise'];
    [...select.options].filter(option => option.value).sort((a, b) => order.indexOf(a.value) - order.indexOf(b.value)).forEach(option => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = origin ? 'button outline' : 'jb-wrapped-shape-button';
      button.dataset.optionValue = option.value;
      if (!origin) {
        const image = document.createElement('img');
        image.src = wrappedShapeImages[option.value.toLowerCase()];
        image.alt = '';
        image.width = 64;
        image.height = 64;
        image.decoding = 'async';
        button.append(image);
      }
      const caption = document.createElement('span');
      caption.textContent = origin ? (option.value === 'Natural' ? 'All natural' : 'All lab-grown') : option.textContent;
      button.append(caption);
      button.addEventListener('click', () => {
        if (button.disabled || select.value === option.value) return;
        select.value = option.value;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
      buttons.append(button);
    });
    select.classList.add('jb-first-origin-source');
    select.setAttribute('aria-hidden', 'true');
    select.tabIndex = -1;
    const source = select.closest('.select') || select;
    source.classList.add('jb-wrapped-native-source');
    source.after(buttons);
    if (origin) {
      const note = document.createElement('p');
      note.className = 'jb-stone-origin__note';
      note.textContent = 'Your choice applies to the diamond in this creation.';
      buttons.after(note);
    }
    const sync = () => {
      [...buttons.children].forEach(button => {
        const option = [...select.options].find(item => item.value === button.dataset.optionValue);
        button.disabled = !option || option.disabled || option.dataset.available === 'false';
        button.setAttribute('aria-pressed', String(button.dataset.optionValue === select.value));
      });
    };
    field.jbWrappedChoiceSync = sync;
    select.addEventListener('input', sync);
    select.addEventListener('change', sync);
    sync();
  }
  // One owner for Wrapped metadata and its five-view gallery. Other products stay native.
  const wrappedTransitionControllers = new WeakMap();
  class WrappedImagePool {
    constructor(limit = 3) { this.limit = limit; this.running = 0; this.jobs = new Map(); this.clock = 0; }
    load(url, priority = 0, important = false) {
      let job = this.jobs.get(url);
      if (job) { job.priority = Math.max(job.priority, priority); job.order = ++this.clock; this.pump(); return job.promise; }
      job = { url, priority, important, order: ++this.clock, state: 'queued' };
      job.promise = new Promise((resolve, reject) => { job.resolve = resolve; job.reject = reject; });
      this.jobs.set(url, job); this.pump(); return job.promise;
    }
    pump() {
      if (this.pruning) return;
      while (this.running < this.limit) {
        const job = [...this.jobs.values()].filter(item => item.state === 'queued').sort((a, b) => b.priority - a.priority || b.order - a.order)[0];
        if (!job) break;
        job.state = 'running'; this.running++;
        const image = new Image(); image.decoding = 'async'; image.fetchPriority = job.important ? 'high' : 'low';
        let settled = false;
        const finish = error => {
          if (settled) return; settled = true;
          clearTimeout(timer); image.onload = null; image.onerror = null; this.running--;
          if (error) { this.jobs.delete(job.url); job.reject(error); }
          else { job.state = 'ready'; job.resolve(job.url); }
          this.pump();
        };
        const timer = setTimeout(() => finish(new Error('Photograph load timed out')), 20000);
        job.cancel = () => { finish(new Error('Superseded photograph')); image.src = ''; };
        image.onerror = () => finish(new Error('Photograph unavailable'));
        image.onload = async () => {
          try { if (image.decode) await image.decode(); if (!image.naturalWidth) throw new Error('Photograph has no dimensions'); finish(); }
          catch (error) { finish(error); }
        };
        image.src = job.url;
      }
    }
    keep(urls) {
      const wanted = new Set(urls);
      this.pruning = true;
      [...this.jobs.values()].forEach(job => {
        if (job.state === 'ready' || wanted.has(job.url)) return;
        if (job.state === 'running') job.cancel();
        else { this.jobs.delete(job.url); job.reject(new Error('Superseded photograph')); }
      });
      this.pruning = false; this.pump();
    }
  }
  const wrappedImagePool = new WrappedImagePool();
  const wrappedViews = ['front', 'upright', 'side', 'profile', 'detail'];
  const wrappedSlug = value => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  class WrappedTransitionController {
    constructor(root, info, scope, manifest, groups) {
      this.root = root; this.info = info; this.scope = scope; this.manifest = manifest; this.groups = groups;
      this.slider = root.querySelector('product-slider'); this.gallery = root.querySelector('.product-image-container');
      this.variants = new Map(manifest.variants.map(variant => [JSON.stringify(variant.options), variant]));
      this.byId = new Map(manifest.variants.map(variant => [String(variant.id), variant]));
      this.lifecycle = new AbortController(); this.revision = 0; this.requestedKey = ''; this.committedKey = ''; this.fade = Promise.resolve();
      this.root.dataset.jbWrappedTransitions = 'true'; this.root.dataset.jbWrappedGallery = 'true';
      this.status = document.createElement('p'); this.status.className = 'jb-wrapped-gallery-status visually-hidden';
      this.status.setAttribute('role', 'status'); this.status.setAttribute('aria-live', 'polite'); this.status.hidden = true;
      this.retry = document.createElement('button'); this.retry.type = 'button'; this.retry.className = 'jb-wrapped-gallery-retry'; this.retry.textContent = 'Try again'; this.retry.hidden = true;
      this.retry.addEventListener('click', () => this.requestGallery(this.requestedKey, true), { signal: this.lifecycle.signal });
      this.gallery.append(this.status, this.retry);
      this.select({ initial: true, history: false });
      customElements.whenDefined('variant-selects').then(() => this.installNativeHook());
      window.addEventListener('popstate', () => this.onPopState(), { signal: this.lifecycle.signal });
      this.root.addEventListener('click', event => {
        if (event.target.closest('button.jb-request-price-button')) this.syncQuote();
      }, { capture: true, signal: this.lifecycle.signal });
      this.scope.addEventListener('pointerover', event => this.hint(event.target), { passive: true, signal: this.lifecycle.signal });
      this.scope.addEventListener('focusin', event => this.hint(event.target), { signal: this.lifecycle.signal });
      this.root.addEventListener('jb:experience-dispose', () => this.dispose(), { once: true, signal: this.lifecycle.signal });
    }
    fields() {
      return [...this.scope.querySelectorAll('fieldset[data-index]')].sort((a, b) => Number(a.dataset.index.replace('option', '')) - Number(b.dataset.index.replace('option', '')));
    }
    values() { return this.fields().map(field => field.querySelector('select')?.value || field.querySelector('input:checked')?.value || ''); }
    galleryKey(values) {
      const shape = this.manifest.optionNames.findIndex(name => wrappedSlug(name) === 'shape');
      const metal = this.manifest.optionNames.findIndex(name => wrappedSlug(name) === 'metal');
      return wrappedSlug(values[shape]) + '|' + wrappedSlug(values[metal]);
    }
    imageUrl(slide) {
      const image = slide.querySelector('img');
      const candidates = (image?.getAttribute('srcset') || image?.getAttribute('data-srcset') || '').split(',').map(value => {
        const match = value.trim().match(/^(\S+)\s+(\d+)w$/); return match ? { url: new URL(match[1], location.href).href, width: Number(match[2]) } : null;
      }).filter(Boolean).sort((a, b) => a.width - b.width);
      const desired = Math.ceil(this.slider.clientWidth * (window.devicePixelRatio || 1));
      if (candidates.length) return (candidates.find(item => item.width >= desired) || candidates[candidates.length - 1]).url;
      const url = new URL(image?.currentSrc || image?.src || slide.querySelector('.product-single__media-zoom').href, location.href);
      if (url.searchParams.has('width')) url.searchParams.set('width', String(Math.min(desired, Number(image?.getAttribute('width')) || desired)));
      return url.href;
    }
    installNativeHook() {
      if (!this.root.isConnected || this.lifecycle.signal.aborted || typeof this.scope.renderVariantInfo !== 'function') return;
      this.originalRender = this.scope.renderVariantInfo;
      this.scope._variantRequest = (this.scope._variantRequest || 0) + 1; this.scope._variantController?.abort();
      this.scope.renderVariantInfo = () => this.select({ history: true });
      this.select({ initial: true, history: false, force: true });
    }
    select({ initial = false, history = false, force = false } = {}) {
      if (!this.root.isConnected || this.lifecycle.signal.aborted) return;
      const values = this.values(); const variant = this.variants.get(JSON.stringify(values));
      if (!variant) return;
      const key = this.galleryKey(values); const group = this.groups.get(key);
      if (!group || group.length !== wrappedViews.length) return;
      if (!force && this.lastVariantId === String(variant.id)) { this.updateDetails(values); this.scope.toggleAddButton?.(!variant.available, window.theme?.variantStrings?.soldOut); return; }
      this.lastVariantId = String(variant.id);
      const frontId = Number(group[0].id.split('-').pop());
      this.scope._variantRequest = (this.scope._variantRequest || 0) + 1; this.scope._variantController?.abort();
      this.scope.currentVariant = { id: Number(variant.id), available: !!variant.available, featured_media: { id: frontId } };
      this.scope.options = values; this.scope.fieldsets = this.fields();
      this.scope.updateVariantText?.();
      const state = this.scope.querySelector('#SelectedVariant-' + this.scope.dataset.section);
      if (state) { state.dataset.variantId = String(variant.id); state.dataset.available = String(variant.available); state.dataset.featuredMediaId = String(frontId); }
      this.info.querySelectorAll('[data-jb-share-state]').forEach(node => {
        if (node.dataset.variantId !== String(variant.id)) node.dataset.variantId = String(variant.id);
        if (node.dataset.sku !== variant.sku) node.dataset.sku = variant.sku;
      });
      this.info.querySelectorAll('[data-reference]').forEach(node => { if (node.textContent !== variant.sku) node.textContent = variant.sku; });
      this.updateAvailability(values); this.scope.updateVariantInput?.();
      if (history) this.scope.updateURL?.();
      this.scope.toggleAddButton?.(!variant.available, window.theme?.variantStrings?.soldOut);
      this.updateDetails(values); this.syncQuote(variant, values);
      if (initial && !this.committedKey) this.commit(group, key, false);
      else if (key !== this.requestedKey) this.requestGallery(key);
      this.requestedKey = key;
    }
    updateAvailability(values) {
      this.fields().forEach((field, position) => {
        field.querySelectorAll('option, input[type="radio"]').forEach(node => {
          const available = this.manifest.variants.some(variant => variant.available && variant.options[position] === node.value && variant.options.every((value, index) => index === position || value === values[index]));
          node.dataset.available = String(available);
        });
      });
      this.scope.setDisabled?.();
      this.fields().forEach(field => field.jbWrappedChoiceSync?.());
    }
    updateDetails(values) {
      const choices = Object.fromEntries(this.manifest.optionNames.map((name, index) => [wrappedSlug(name), values[index]]));
      const weights = { oval: '5.23', pear: '5.42', marquise: '5.34' };
      const shape = choices.shape; const metal = choices.metal;
      const copy = { metal, shape: shape + ' diamond', origin: choices['diamond-origin'], weight: wrappedSlug(metal) === '18k-rose-gold' ? 'Confirmed with your quotation' : 'Approximately ' + weights[wrappedSlug(shape)] + ' g' };
      Object.entries(copy).forEach(([key, value]) => this.info.querySelectorAll('[data-jb-wrapped-' + key + '] dd').forEach(cell => { if (cell.textContent !== value) cell.textContent = value; }));
    }
    syncQuote(variant, values) {
      values ||= this.values(); variant ||= this.variants.get(JSON.stringify(values));
      const form = document.querySelector('#RequestPriceForm'); if (!form || !variant) return;
      const origin = values[this.manifest.optionNames.findIndex(name => wrappedSlug(name) === 'diamond-origin')];
      const entries = { 'Variant ID': String(variant.id), SKU: variant.sku, 'Selected options': this.manifest.optionNames.map((name, index) => name + ': ' + values[index]).join('; '), 'Stone origin': origin, 'Origin applies to': 'The diamond in this creation.' };
      Object.entries(entries).forEach(([name, value]) => {
        let field = [...form.querySelectorAll('input')].find(node => node.name === 'contact[' + name + ']');
        if (!field) { field = document.createElement('input'); field.type = 'hidden'; field.name = 'contact[' + name + ']'; form.append(field); }
        if (field.value !== value) field.value = value; field.disabled = !value;
      });
    }
    hint(target) {
      const values = this.values(); const shapeButton = target.closest('.jb-wrapped-shape-button');
      if (shapeButton) values[this.manifest.optionNames.findIndex(name => wrappedSlug(name) === 'shape')] = shapeButton.dataset.optionValue;
      else {
        const label = target.closest('label'); const input = label?.htmlFor ? document.getElementById(label.htmlFor) : target.closest('input');
        if (!input || input.closest('fieldset')?.dataset.handle !== 'metal') return;
        values[this.manifest.optionNames.findIndex(name => wrappedSlug(name) === 'metal')] = input.value;
      }
      const group = this.groups.get(this.galleryKey(values));
      if (group && !navigator.connection?.saveData && !this.slider.getAttribute('aria-busy')?.includes('true')) wrappedImagePool.load(this.imageUrl(group[0]), 1).catch(() => {});
    }
    async requestGallery(key, retry = false) {
      const group = this.groups.get(key); if (!group || (!retry && key === this.requestedKey)) return;
      const revision = ++this.revision; this.requestedKey = key;
      if (key === this.committedKey) { this.clearStatus(); return; }
      this.slider.setAttribute('aria-busy', 'true'); this.status.textContent = 'Updating the selected ring photographs.';
      this.status.classList.add('visually-hidden'); this.status.hidden = false; this.retry.hidden = true;
      try {
        const wanted = group.map(slide => this.imageUrl(slide));
        wrappedImagePool.keep(wanted);
        await Promise.all(wanted.map((url, index) => {
          const current = this.groups.get(this.committedKey)?.[index]?.getBoundingClientRect();
          const visible = current && current.bottom > 0 && current.top < window.innerHeight;
          return wrappedImagePool.load(url, 100 + revision, !!visible);
        }));
        if (revision !== this.revision || !this.root.isConnected || this.lifecycle.signal.aborted) return;
        group.forEach((slide, index) => {
          const image = slide.querySelector('img'); if (!image) return;
          image.src = wanted[index]; image.sizes = this.slider.clientWidth + 'px'; image.loading = 'eager'; image.classList.remove('lazyload'); image.classList.add('no-blur');
        });
        this.commit(group, key, !window.matchMedia('(prefers-reduced-motion: reduce)').matches);
        this.clearStatus();
      } catch (error) {
        if (revision !== this.revision || !this.root.isConnected || this.lifecycle.signal.aborted) return;
        this.slider.setAttribute('aria-busy', 'false'); this.status.textContent = 'The selected photographs could not load.';
        this.status.classList.remove('visually-hidden'); this.status.hidden = false; this.retry.hidden = false;
      }
    }
    clearStatus() { this.slider.setAttribute('aria-busy', 'false'); this.status.hidden = true; this.retry.hidden = true; }
    makeCover() {
      if (window.JBProductGalleryMotion) return window.JBProductGalleryMotion.capture(this.gallery, this.groups.get(this.committedKey) || []);
      const cover = document.createElement('div'); cover.className = 'jb-wrapped-transition-cover'; cover.setAttribute('aria-hidden', 'true'); cover.inert = true;
      cover.style.top = this.slider.offsetTop + 'px'; cover.style.left = this.slider.offsetLeft + 'px'; cover.style.width = this.slider.offsetWidth + 'px';
      const track = document.createElement('div'); track.className = 'jb-wrapped-transition-cover__track';
      track.style.gap = getComputedStyle(this.slider).gap;
      if (window.innerWidth < 768) { cover.style.height = this.slider.clientHeight + 'px'; track.style.transform = 'translateX(-' + this.slider.scrollLeft + 'px)'; }
      const previous = this.groups.get(this.committedKey) || [];
      previous.forEach(slide => {
        const source = slide.querySelector('img'); const frame = document.createElement('div'); frame.className = 'jb-wrapped-transition-cover__frame';
        const image = source.cloneNode(false); image.removeAttribute('id'); image.removeAttribute('alt'); image.alt = ''; image.loading = 'eager'; image.decoding = 'async';
        const computed = getComputedStyle(source); image.style.padding = computed.padding; image.style.objectFit = computed.objectFit;
        frame.append(image); track.append(frame);
      });
      cover.append(track);
      this.gallery.append(cover); return cover;
    }
    commit(group, key, animate) {
      const scrollLeft = this.slider.scrollLeft;
      this.animation?.cancel(); this.cover?.remove();
      const cover = animate && this.committedKey ? this.makeCover() : null;
      this.slider._pendingZoom = null; this.slider.pswp?.close();
      const visible = new Set(group); const fragment = document.createDocumentFragment();
      this.slider.querySelectorAll('.product-images__slide').forEach(slide => {
        const hide = !visible.has(slide); slide.dataset.jbWrappedHidden = String(hide); slide.hidden = hide; slide.setAttribute('aria-hidden', String(hide)); slide.classList.toggle('is-active', !hide);
      });
      group.forEach((slide, index) => { const link = slide.querySelector('.product-single__media-zoom'); if (link) link.dataset.index = String(index); fragment.append(slide); });
      this.slider.prepend(fragment);
      this.slider.scrollLeft = scrollLeft;
      this.committedKey = key; this.root.dataset.jbWrappedRendered = key;
      wrappedSliderGuard(this.slider);
      this.slider.onPaginationResize?.();
      if (cover && typeof cover.animate === 'function') {
        const animation = cover.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 220, easing: 'ease-out', fill: 'forwards' });
        this.cover = cover; this.animation = animation;
        this.fade = animation.finished.catch(() => {}).then(() => { cover.remove(); if (this.cover === cover) { this.cover = null; this.animation = null; } });
      } else cover?.remove();
      // No page scroll, gallery scroll or native updateMedia: all five slots keep their tops.
    }
    onPopState() {
      const id = new URL(location.href).searchParams.get('variant'); const variant = this.byId.get(id || String(this.manifest.variants[0].id)); if (!variant) return;
      this.fields().forEach((field, index) => {
        const select = field.querySelector('select'); if (select) select.value = variant.options[index];
        else field.querySelectorAll('input[type="radio"]').forEach(input => { input.checked = input.value === variant.options[index]; });
      });
      this.select({ history: false }); this.scope.updateOther?.();
      document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: this.scope.currentVariant, variantTitle: variant.options.join(' / '), sectionId: this.scope.dataset.section } }));
    }
    dispose() {
      ++this.revision; this.lifecycle.abort(); this.animation?.cancel(); this.cover?.remove(); clearTimeout(this.warmTimer);
      if (this.idle && 'cancelIdleCallback' in window) cancelIdleCallback(this.idle);
      if (this.originalRender) this.scope.renderVariantInfo = this.originalRender;
    }
  }
  function mountWrappedTransitions(info, scope) {
    const root = info.closest('.jb-product-experience'); if (!root || scope.tagName !== 'VARIANT-SELECTS') return false;
    const existing = wrappedTransitionControllers.get(root); if (existing) { existing.select(); return true; }
    const node = document.querySelector('script[data-jb-wrapped-variants]'); if (!node) return false;
    try {
      const manifest = JSON.parse(node.textContent);
      if (manifest.handle !== 'wrapped-solitaire-diamond-ring' || manifest.optionNames?.length !== 3 || manifest.variants?.length !== 18 || new Set(manifest.variants.map(variant => JSON.stringify(variant.options))).size !== 18) return false;
      const marker = /#jb-wrapped_(oval|pear|marquise)_(18k-(?:white|yellow|rose)-gold)_(front|upright|side|profile|detail)\b/i;
      const grouped = new Map();
      root.querySelectorAll('.product-images__slide').forEach(slide => {
        const image = slide.querySelector('img[alt]'); const match = image?.alt.match(marker);
        const shape = slide.dataset.jbWrappedShape || match?.[1]?.toLowerCase();
        const metal = slide.dataset.jbWrappedMetal || match?.[2]?.toLowerCase();
        const view = slide.dataset.jbWrappedView || match?.[3]?.toLowerCase();
        if (!shape || !metal || !wrappedViews.includes(view)) return;
        slide.dataset.jbWrappedShape = shape; slide.dataset.jbWrappedMetal = metal; slide.dataset.jbWrappedView = view;
        if (match) image.alt = image.alt.replace(marker, '').trim();
        const key = shape + '|' + metal; if (!grouped.has(key)) grouped.set(key, new Map());
        const views = grouped.get(key); if (views.has(view)) throw new Error('Duplicate Wrapped view'); views.set(view, slide);
      });
      if (grouped.size !== 9 || [...grouped.values()].some(views => views.size !== 5)) return false;
      const groups = new Map([...grouped].map(([key, views]) => [key, wrappedViews.map(view => views.get(view))]));
      const controller = new WrappedTransitionController(root, info, scope, manifest, groups); wrappedTransitionControllers.set(root, controller); return true;
    } catch (error) { return false; }
  }

  function fiveStoneManifest() {
    const node = document.querySelector('script[data-jb-five-stone-variants]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (error) { return null; }
  }
  function fiveStoneChoiceButtons(field, kind, manifest) {
    const select = field?.querySelector('select');
    if (!select) return;
    if (field.jbWrappedChoiceSync) { field.jbWrappedChoiceSync(); return; }
    const version = kind === 'version';
    field.classList.add(version ? 'jb-five-stone-version' : 'jb-wrapped-shape');
    const group = document.createElement('div');
    group.className = version ? 'jb-five-stone-version-buttons' : 'jb-wrapped-shape-buttons';
    group.setAttribute('role', 'group'); group.setAttribute('aria-label', version ? 'Version' : 'Diamond shape');
    const order = version ? ['Petite', 'Original', 'Large'] : manifest?.configuration?.shapeOrder || [...select.options].map(option => option.value);
    [...select.options].filter(option => option.value).sort((a, b) => order.indexOf(a.value) - order.indexOf(b.value)).forEach(option => {
      const button = document.createElement('button'); button.type = 'button';
      button.className = version ? 'button outline' : 'jb-wrapped-shape-button'; button.dataset.optionValue = option.value;
      const url = manifest?.configuration?.shapeImages?.[wrappedSlug(option.value)];
      if (!version && url && /^https:\/\/cdn\.shopify\.com\//.test(url)) {
        const image = document.createElement('img'); image.src = url; image.alt = ''; image.width = 64; image.height = 64; image.decoding = 'async'; button.append(image);
      }
      const caption = document.createElement('span'); caption.textContent = option.textContent; button.append(caption);
      button.addEventListener('click', () => {
        if (button.disabled || select.value === option.value) return;
        select.value = option.value;
        select.dispatchEvent(new Event('input', { bubbles: true })); select.dispatchEvent(new Event('change', { bubbles: true }));
      });
      group.append(button);
    });
    select.classList.add('jb-first-origin-source'); select.setAttribute('aria-hidden', 'true'); select.tabIndex = -1;
    const source = select.closest('.select') || select; source.classList.add('jb-wrapped-native-source'); source.after(group);
    const sync = () => [...group.children].forEach(button => {
      const option = [...select.options].find(item => item.value === button.dataset.optionValue);
      button.disabled = !option || option.disabled || option.dataset.available === 'false';
      button.setAttribute('aria-pressed', String(button.dataset.optionValue === select.value));
    });
    field.jbWrappedChoiceSync = sync; select.addEventListener('input', sync); select.addEventListener('change', sync); sync();
  }
  class FiveStoneTransitionController extends WrappedTransitionController {
    constructor(root, info, scope, manifest, groups) {
      super(root, info, scope, manifest, groups);
      this.root.dataset.jbFiveStoneGallery = 'true';
      const note = scope.querySelector('jb-stone-origin .jb-stone-origin__note');
      if (note) note.textContent = 'Your choice applies to all five diamonds in this creation.';
      scope.addEventListener('change', event => {
        if (!event.target.matches?.('select[data-jb-stone-origin]')) return;
        this.updateDetails(this.values()); this.syncQuote();
      }, { capture: true, signal: this.lifecycle.signal });
    }
    galleryKey(values) { return values.map(wrappedSlug).join('|'); }
    selectedStyle(values) { return this.manifest.configuration.styles.find(style => wrappedSlug(style.version) === wrappedSlug(values[0]) && wrappedSlug(style.shape) === wrappedSlug(values[1])); }
    writeChoices(values) {
      this.fields().forEach((field, index) => {
        const select = field.querySelector('select');
        if (select) { select.value = values[index]; select.jbRefinedSelectSync?.(); }
        else field.querySelectorAll('input[type="radio"]').forEach(input => { input.checked = input.value === values[index]; });
      });
    }
    resolveVariant(values) {
      const exact = this.variants.get(JSON.stringify(values)); if (exact) return exact;
      const previous = this.lastValues || values;
      const changed = values.findIndex((value, index) => value !== previous[index]);
      const candidates = this.manifest.variants.filter(variant => variant.available && (changed < 0 || variant.options[changed] === values[changed]));
      const weights = [4, 1, 8];
      return candidates.map((variant, order) => ({ variant, order, score: variant.options.reduce((score, value, index) => score + (value === values[index] ? weights[index] : 0), 0) }))
        .sort((a, b) => b.score - a.score || a.order - b.order)[0]?.variant;
    }
    select({ initial = false, history = false, force = false } = {}) {
      if (!this.root.isConnected || this.lifecycle.signal.aborted) return;
      const requested = this.values(); const variant = this.resolveVariant(requested); if (!variant) return;
      const values = [...variant.options]; const key = this.galleryKey(values); const group = this.groups.get(key);
      const style = this.selectedStyle(values); if (!group || group.length !== style?.views.length) return;
      if (values.some((value, index) => value !== requested[index])) this.writeChoices(values);
      this.lastValues = values;
      if (!force && this.lastVariantId === String(variant.id)) { this.updateDetails(values); this.scope.toggleAddButton?.(!variant.available, window.theme?.variantStrings?.soldOut); return; }
      this.lastVariantId = String(variant.id);
      const frontId = Number(group[0].id.split('-').pop());
      this.scope._variantRequest = (this.scope._variantRequest || 0) + 1; this.scope._variantController?.abort();
      this.scope.currentVariant = { id: Number(variant.id), available: !!variant.available, featured_media: { id: frontId } };
      this.scope.options = values; this.scope.fieldsets = this.fields(); this.scope.updateVariantText?.();
      const state = this.scope.querySelector('#SelectedVariant-' + this.scope.dataset.section);
      if (state) { state.dataset.variantId = String(variant.id); state.dataset.available = String(variant.available); state.dataset.featuredMediaId = String(frontId); }
      this.info.querySelectorAll('[data-jb-share-state]').forEach(node => {
        if (node.dataset.variantId !== String(variant.id)) node.dataset.variantId = String(variant.id);
        if (node.dataset.sku !== variant.sku) node.dataset.sku = variant.sku;
      });
      this.info.querySelectorAll('[data-reference], .product-sku').forEach(node => { if (node.textContent !== variant.sku) node.textContent = variant.sku; });
      this.updateAvailability(values); this.scope.updateVariantInput?.();
      if (history) this.scope.updateURL?.();
      this.scope.toggleAddButton?.(!variant.available, window.theme?.variantStrings?.soldOut);
      this.updateDetails(values); this.syncQuote(variant, values);
      if (initial && !this.committedKey) this.commit(group, key, false);
      else if (key !== this.requestedKey) this.requestGallery(key);
      this.requestedKey = key;
    }
    updateAvailability(values) {
      this.fields().forEach((field, position) => {
        field.querySelectorAll('option, input[type="radio"]').forEach(node => {
          const available = this.manifest.variants.some(variant => variant.available && variant.options[position] === node.value && (position < 2 ? variant.options[2] === values[2] : variant.options.every((value, index) => index === position || value === values[index])));
          node.dataset.available = String(available);
        });
      });
      this.scope.setDisabled?.(); this.fields().forEach(field => field.jbWrappedChoiceSync?.());
    }
    origin() { return this.scope.querySelector('select[data-jb-stone-origin]')?.value || ''; }
    updateDetails(values) {
      const style = this.selectedStyle(values); const origin = this.origin();
      const copy = { version: values[0], shape: values[1] + ' diamonds', metal: values[2], origin: origin || labels.originRequired };
      Object.entries(copy).forEach(([key, value]) => this.info.querySelectorAll('[data-jb-five-stone-' + key + '] dd').forEach(cell => { if (cell.textContent !== value) cell.textContent = value; }));
      this.info.querySelectorAll('[data-jb-five-stone-spec]').forEach(row => {
        const key = row.dataset.jbFiveStoneSpec;
        const value = key === 'metalWeight' ? style?.specs?.metalWeights?.[values[2]] : style?.specs?.[key];
        const cell = row.querySelector('dd'); const text = value == null || value === '' ? 'Confirmed with your quotation' : String(value);
        if (cell && cell.textContent !== text) cell.textContent = text;
      });
    }
    syncQuote(variant, values) {
      values ||= this.values(); variant ||= this.variants.get(JSON.stringify(values));
      const form = document.querySelector('#RequestPriceForm'); if (!form || !variant) return;
      const origin = this.origin();
      const options = this.manifest.optionNames.map((name, index) => name + ': ' + values[index]);
      if (origin) options.push('Stone origin: ' + origin);
      const entries = { 'Variant ID': String(variant.id), SKU: variant.sku, 'Selected options': options.join('; '), 'Stone origin': origin, 'Origin applies to': origin ? 'All five diamonds in this creation.' : '' };
      Object.entries(entries).forEach(([name, value]) => {
        let field = [...form.querySelectorAll('input')].find(node => node.name === 'contact[' + name + ']');
        if (!field) { field = document.createElement('input'); field.type = 'hidden'; field.name = 'contact[' + name + ']'; form.append(field); }
        if (field.value !== value) field.value = value; field.disabled = !value;
      });
      const summary = form.querySelector('[data-jb-origin-summary]');
      if (summary) { summary.textContent = origin ? summary.dataset.label + ': ' + origin : ''; summary.hidden = !origin; }
    }
    hint(target) {
      const values = this.values(); const button = target.closest('[data-option-value]');
      if (button) { const field = button.closest('fieldset[data-index]'); const index = this.fields().indexOf(field); if (index < 0) return; values[index] = button.dataset.optionValue; }
      else {
        const label = target.closest('label'); const input = label?.htmlFor ? document.getElementById(label.htmlFor) : target.closest('input');
        if (!input || input.closest('fieldset')?.dataset.handle !== 'metal') return; values[2] = input.value;
      }
      const variant = this.resolveVariant(values); const group = variant && this.groups.get(this.galleryKey(variant.options));
      if (group && !navigator.connection?.saveData && this.slider.getAttribute('aria-busy') !== 'true') wrappedImagePool.load(this.imageUrl(group[0]), 1).catch(() => {});
    }
  }
  function mountFiveStoneTransitions(info, scope) {
    const root = info.closest('.jb-product-experience'); if (!root || scope.tagName !== 'VARIANT-SELECTS') return false;
    const existing = wrappedTransitionControllers.get(root); if (existing) { existing.select(); return true; }
    const manifest = fiveStoneManifest(); if (!manifest) return false;
    try {
      if (manifest.handle !== 'five-stone-diamond-band' || JSON.stringify(manifest.optionNames) !== JSON.stringify(['Version', 'Shape', 'Metal']) || manifest.configuration?.schemaVersion !== 1 || !manifest.variants?.length) return false;
      const styles = manifest.configuration.styles; if (!Array.isArray(styles) || !styles.length) return false;
      const styleKey = (version, shape) => wrappedSlug(version) + '|' + wrappedSlug(shape);
      const stylesByKey = new Map();
      styles.forEach(style => {
        const key = styleKey(style.version, style.shape);
        if (stylesByKey.has(key) || !Array.isArray(style.views) || !style.views.length || style.views[0] !== 'front' || new Set(style.views).size !== style.views.length || style.views.some(view => !wrappedViews.includes(view))) throw new Error('Invalid Five Stone style contract');
        stylesByKey.set(key, style);
      });
      const required = new Set(manifest.variants.map(variant => variant.options.map(wrappedSlug).join('|')));
      const actualStyles = new Set(manifest.variants.map(variant => styleKey(variant.options[0], variant.options[1])));
      if (required.size !== manifest.variants.length || actualStyles.size !== stylesByKey.size || [...actualStyles].some(key => !stylesByKey.has(key))) return false;
      const marker = /#jb-five-stone_(petite|original|large)_([a-z0-9-]+)_(18k-(?:white|yellow|rose)-gold)_(front|upright|side|profile|detail)\b/i;
      const grouped = new Map();
      root.querySelectorAll('.product-images__slide').forEach(slide => {
        const image = slide.querySelector('img[alt]'); const match = image?.alt.match(marker);
        const version = slide.dataset.jbFiveStoneVersion || match?.[1]?.toLowerCase();
        const shape = slide.dataset.jbFiveStoneShape || match?.[2]?.toLowerCase();
        const metal = slide.dataset.jbFiveStoneMetal || match?.[3]?.toLowerCase();
        const view = slide.dataset.jbFiveStoneView || match?.[4]?.toLowerCase();
        if (!version || !shape || !metal || !view) return;
        const key = [version, shape, metal].join('|');
        if (!required.has(key) || !stylesByKey.get(version + '|' + shape)?.views.includes(view)) throw new Error('Unexpected Five Stone photograph');
        slide.dataset.jbFiveStoneVersion = version; slide.dataset.jbFiveStoneShape = shape; slide.dataset.jbFiveStoneMetal = metal; slide.dataset.jbFiveStoneView = view;
        if (match) image.alt = image.alt.replace(marker, '').trim();
        if (!grouped.has(key)) grouped.set(key, new Map()); const views = grouped.get(key);
        if (views.has(view)) throw new Error('Duplicate Five Stone photograph'); views.set(view, slide);
      });
      if (grouped.size !== required.size || [...required].some(key => {
        const [version, shape] = key.split('|'); const views = grouped.get(key); return !views || views.size !== stylesByKey.get(version + '|' + shape).views.length;
      })) return false;
      const groups = new Map([...grouped].map(([key, views]) => {
        const [version, shape] = key.split('|'); return [key, stylesByKey.get(version + '|' + shape).views.map(view => views.get(view))];
      }));
      const controller = new FiveStoneTransitionController(root, info, scope, manifest, groups); wrappedTransitionControllers.set(root, controller); return true;
    } catch (error) { return false; }
  }

  function wrappedSliderGuard(slider) {
    const install = () => {
      if (!slider.isConnected || slider.jbWrappedBuildItems || typeof slider.buildItems !== 'function') return;
      const buildItems = slider.buildItems;
      slider.buildItems = function (activeImages) {
        const matching = Array.from(activeImages || []).filter(item => item.dataset.jbWrappedHidden === 'false');
        // zoomClick reads activeImages again to resolve the clicked photograph index.
        this.activeImages = matching;
        return buildItems.call(this, matching);
      };
      slider.jbWrappedBuildItems = true;
    };
    install();
    if (!slider.jbWrappedBuildItems && !slider.jbWrappedGuardPending) {
      slider.jbWrappedGuardPending = true;
      customElements.whenDefined('product-slider').then(install);
    }
  }
  function wrappedGallery(info, scope) {
    if (mountWrappedTransitions(info, scope)) return;
    const root = info.closest('.jb-product-experience');
    const selected = handle => {
      const field = scope.querySelector('fieldset[data-handle="' + handle + '"]');
      return field?.querySelector('select')?.value || field?.querySelector('input:checked')?.value || '';
    };
    const slug = value => value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    const shapeValue = selected('shape');
    const metalValue = selected('metal');
    const originValue = selected('diamond-origin');
    const shape = slug(shapeValue);
    const metal = slug(metalValue);
    if (!root || !shape || !metal) return;
    const weights = { oval: '5.23', pear: '5.42', marquise: '5.34' };
    const details = {
      metal: metalValue,
      shape: shapeValue + ' diamond',
      origin: originValue,
      weight: metal === '18k-rose-gold' ? 'Confirmed with your quotation' : 'Approximately ' + weights[shape] + ' g'
    };
    Object.entries(details).forEach(([key, value]) => {
      info.querySelectorAll('[data-jb-wrapped-' + key + '] dd').forEach(cell => {
        if (cell.textContent !== value) cell.textContent = value;
      });
    });
    const slides = [...root.querySelectorAll('.product-images__slide')];
    const views = ['front', 'upright', 'side', 'profile', 'detail'];
    const marker = /#jb-wrapped_(oval|pear|marquise)_(18k-(?:white|yellow|rose)-gold)_(front|upright|side|profile|detail)\b/i;
    slides.forEach(slide => {
      if (slide.dataset.jbWrappedShape) return;
      const image = slide.querySelector('img[alt]');
      const match = image?.alt.match(marker);
      if (!match) return;
      slide.dataset.jbWrappedShape = match[1].toLowerCase();
      slide.dataset.jbWrappedMetal = match[2].toLowerCase();
      slide.dataset.jbWrappedView = match[3].toLowerCase();
      image.alt = image.alt.replace(marker, '').trim();
    });
    const matching = slides.filter(slide => slide.dataset.jbWrappedShape === shape && slide.dataset.jbWrappedMetal === metal && views.includes(slide.dataset.jbWrappedView));
    // Keep the existing gallery usable until the selected photographs are uploaded.
    if (!matching.length) return;
    const chosen = new Set(views.map(view => matching.find(slide => slide.dataset.jbWrappedView === view)).filter(Boolean));
    const visibleMedia = new Set([...chosen].map(slide => slide.id.split('-').pop()));
    root.dataset.jbWrappedGallery = 'true';
    let changed = false;
    [...slides, ...root.querySelectorAll('.product-thumbnail')].forEach(item => {
      const hide = !visibleMedia.has(item.id.split('-').pop());
      if (item.dataset.jbWrappedHidden !== String(hide)) {
        item.dataset.jbWrappedHidden = String(hide);
        item.hidden = hide;
        item.setAttribute('aria-hidden', String(hide));
        changed = true;
      }
    });
    const sliders = [...root.querySelectorAll('product-slider')];
    sliders.forEach(wrappedSliderGuard);
    if (changed) {
      sliders.forEach(slider => slider.pswp?.close());
      requestAnimationFrame(() => {
        if (!root.isConnected) return;
        sliders.forEach(slider => {
          slider.scrollLeft = 0;
          slider.onPaginationResize?.();
        });
      });
    }
  }
  function sizing(select, info) {
    if (select.dataset.jbFirstSizeBound) return;
    const local = select.closest('jb-ring-size-choice,fieldset');
    const guide = local?.querySelector('jb-size-guide') || info.querySelector('jb-size-guide');
    const opener = guide?.querySelector('.cus_sz_chrt_jsb__btn');
    if(!guide || !opener) return;
    select.dataset.jbFirstSizeBound = 'true';
    let saved = select.value;
    if(![...select.options].some(option => option.value === uncertain)) {
      const option = document.createElement('option'); option.value = uncertain; option.textContent = labels.unsure;
      const first = select.options[0]; select.insertBefore(option, first?.value ? first : first?.nextSibling || null);
    }
    select.addEventListener('change', event => {
      if(select.value === uncertain) { event.stopPropagation(); select.value = saved; opener.click(); }
      else saved = select.value;
    });
    const chart = guide.querySelector('.jb-rs-chart-details');
    if(chart && !chart.querySelector('.jb-first-chart-picker')) {
      const row = document.createElement('div'); row.className = 'jb-first-chart-picker';
      const picker = document.createElement('select'); picker.setAttribute('aria-label',labels.chooseSize);
      const placeholder = document.createElement('option'); placeholder.value = ''; placeholder.textContent = labels.chooseSize; picker.append(placeholder);
      [...select.options].filter(option => option.value && option.value !== uncertain && !option.disabled).forEach(option => picker.append(option.cloneNode(true)));
      picker.value = '';
      const use = document.createElement('button'); use.type = 'button'; use.className = 'jb-rs-primary'; use.textContent = labels.useSize; use.disabled = true;
      picker.addEventListener('change', () => { use.disabled = !picker.value; });
      use.addEventListener('click', () => {
        const option = [...select.options].find(option => option.value === picker.value && !option.disabled);
        if(!option) return;
        select.value = option.value; select.dispatchEvent(new Event('input',{bubbles:true})); select.dispatchEvent(new Event('change',{bubbles:true}));
        guide.close();
      });
      row.append(picker,use); chart.querySelector('summary').after(row);
    }
  }
  function arrange(info) {
    if(!info.closest('.jb-product-experience') || info.dataset.jbQuoteProduct !== 'true') return;
    info.classList.add('jb-first-product');
    const scope = info.querySelector(':scope > .jb-product-variant-scope') || info;
    const title = scope.querySelector('.product-title-container');
    if(!title) return;
    const options = group(scope,'jb-first-options');
    const material = scope.querySelector('.jb-material-choices');
    const wrapped = /\/products\/wrapped-solitaire-diamond-ring(?:[/?#]|$)/.test(scope.dataset.url || scope.querySelector('.jb-request-price-button')?.dataset.productUrl || '');
    const fiveStone = /\/products\/five-stone-diamond-band(?:[/?#]|$)/.test(scope.dataset.url || scope.querySelector('.jb-request-price-button')?.dataset.productUrl || '');
    const catalogControls = scope.querySelector('[data-jb-catalog-controls]');
    info.classList.toggle('jb-wrapped-product', wrapped || fiveStone || !!catalogControls);
    info.classList.toggle('jb-five-stone-product', fiveStone);
    const nativeOrigin = wrapped ? scope.querySelector('fieldset[data-handle="diamond-origin"]') : null;
    const origin = nativeOrigin || scope.querySelector('jb-stone-origin');
    const variations = [...scope.querySelectorAll('.variations')].find(node => !node.classList.contains('jb-material-choices'));
    const requested = scope.querySelector('jb-ring-size-choice');
    if (wrapped) {
      wrappedChoiceButtons(nativeOrigin, 'origin');
      wrappedChoiceButtons(scope.querySelector('fieldset[data-handle="shape"]'), 'shape');
    }
    if (fiveStone) {
      const manifest = fiveStoneManifest();
      fiveStoneChoiceButtons(scope.querySelector('fieldset[data-handle="version"]'), 'version', manifest);
      fiveStoneChoiceButtons(scope.querySelector('fieldset[data-handle="shape"]'), 'shape', manifest);
    }
    ordered(options,[material,origin,catalogControls,variations,requested]);
    if(variations) {
      const fieldsets = [...variations.children].filter(node => node.matches('fieldset'));
      ordered(variations,[...fieldsets.filter(field => !field.dataset.jbRingSizeSystem),...fieldsets.filter(field => field.dataset.jbRingSizeSystem)]);
    }
    originButtons(origin);
    if (wrapped) wrappedGallery(info, scope);
    if (fiveStone) mountFiveStoneTransitions(info, scope);
    const price = scope.querySelector('.product-price-container');
    const purchase = scope.querySelector('.jb-purchase-controls');
    const support = group(scope,'jb-first-support');
    const details = [...info.querySelectorAll('.jb-product-introduction .jb-jewel-spec')];
    if(details.length) { const holder = group(support,'jb-first-details'); [...holder.children].filter(node => !details.includes(node)).forEach(node => node.remove()); ordered(holder,details); }
    const policies = scope.querySelector('.jb-product-policies');
    if(policies && policies.parentNode !== support) support.append(policies);
    after(options,title); after(price,options); after(purchase,price || options); after(support,purchase || price || options);
    let extra = scope.querySelector('collapsible-row.jb-first-services');
    const services = scope.querySelector('.jb-product-services');
    if(services && !extra) {
      const template = document.createElement('template');
      template.innerHTML = '<collapsible-row class="product__accordion accordion jb-first-services"><details><summary><span></span></summary><div class="collapsible__content accordion__content"></div></details></collapsible-row>';
      extra = template.content.firstElementChild;
      extra.querySelector('summary').prepend(document.createTextNode(labels.services));
      extra.querySelector('.collapsible__content').append(services);
      support.after(extra);
    }
    after(extra,support);
    const share = scope.querySelector('jb-product-share');
    if(share) { share.classList.add('jb-first-share'); after(share,extra || support); }
    const launcher = info.querySelector('.jb-wishlist-launcher');
    const clientContent = extra?.querySelector('.collapsible__content');
    if(launcher && clientContent && launcher.parentNode !== clientContent) clientContent.append(launcher);
    const save = purchase?.querySelector('.jb-product-save');
    const gallery = info.closest('.jb-product-experience')?.querySelector('.product-image-container');
    if(save && gallery) { gallery.querySelectorAll('.jb-first-gallery-save').forEach(other => { if(other !== save) other.remove(); }); save.classList.add('jb-first-gallery-save'); gallery.append(save); }
    info.querySelectorAll('select[data-jb-ring-size],fieldset[data-jb-ring-size-system] select').forEach(select => sizing(select,info));
    options.querySelectorAll('select:not(.jb-first-origin-source)').forEach(refineSelect);
  }
  document.addEventListener('click', event => {
    const request = event.target.closest?.('button.jb-request-price-button');
    const info = request?.closest('.jb-first-product');
    const origin = info?.querySelector('jb-stone-origin');
    const select = origin?.querySelector('select[data-jb-stone-origin]');
    if(select && !select.disabled && !select.value) { event.preventDefault(); event.stopImmediatePropagation(); origin.querySelector('.jb-first-origin-error').hidden = false; origin.querySelector('.jb-first-origin-buttons button')?.focus(); }
  },true);
  let queued = false;
  const run = () => { queued = false; document.querySelectorAll('.product-information--inner').forEach(arrange); };
  const schedule = () => { if(!queued) { queued = true; queueMicrotask(run); } };
  const start = () => { run(); new MutationObserver(records => { if(records.some(record => record.type === 'childList' && [...record.addedNodes].some(node => node.nodeType === 1))) schedule(); }).observe(document.body,{childList:true,subtree:true}); };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
  document.addEventListener('shopify:section:load',schedule);
  document.addEventListener('product:variant-change',schedule);
})();



